<template>

	<v-content>
		<v-container fluid fill-height pa-0>

			<div class="WorkManager">

				<div class="WMPanel WMPanel-customers">
					<div class="WMActionBox">
						<div class="buttons">
							<v-btn flat icon>
							<v-icon>add</v-icon>
							</v-btn>
							<v-btn flat icon>
								<v-icon>drag_indicator</v-icon>
							</v-btn>
						</div>
					</div>
					<div class="WMSearchBox">
						<input type="text" placeholder="Müşteri ara">
					</div>
					<div class="WMPanelItems">
						<div class="item" v-for="i in 10" :key="i" :class="{active : i == 3}">
							<img src="https://34yigttpdc638c2g11fbif92-wpengine.netdna-ssl.com/wp-content/uploads/2016/09/default-user-img.jpg" alt="">
							<div class="details">
								<div class="first">Forum Diyarbakır</div>
								<div class="second"></div>
							</div>
						</div>
					</div>
				</div>

				<div class="WMPanel WMPanel-works">
					<div class="WMActionBox">
						<div class="buttons">
							<v-btn flat icon>
							<v-icon>add</v-icon>
							</v-btn>
							<v-btn flat icon>
								<v-icon>drag_indicator</v-icon>
							</v-btn>
						</div>
					</div>
					<div class="WMSearchBox">
						<input type="text" placeholder="İş ara">
					</div>
					<div class="WMPanelItems">
						<div class="item" v-for="i in 10" :key="i" :class="{active : i == 1}">
							<img src="https://images.squarespace-cdn.com/content/50bc0d95e4b0ba52658969b7/1456762240949-8OD7N8GMQUBV8AHIJBU4/?content-type=image%2Fpng" alt="">
							<div class="details">
								<div class="first">Bilbord </div>
								<div class="second"></div>
							</div>
						</div>
					</div>
				</div>


				<div class="WMPanel WMPanel-details">
					<div class="WMPD-topActions">
						<div class="infos">
							<img src="https://34yigttpdc638c2g11fbif92-wpengine.netdna-ssl.com/wp-content/uploads/2016/09/default-user-img.jpg" alt="">
							<div class="details">
								<div class="customer">
									Forum Diyarbakir
								</div>
								<div class="work">Bilboard Tasarımı</div>
							</div>
						</div>
						<div class="actions">
							<div class="buttons">
								<v-btn flat icon>
									<v-icon>attach_file</v-icon>
								</v-btn>
								<v-btn flat icon @click="isOpendDetailsBrif = !isOpendDetailsBrif">
									<v-icon>assignment</v-icon>
								</v-btn>
							</div>
						</div>
					</div>


					<div class="WMPD-body" :class="{opendBrif : isOpendDetailsBrif }">
						<div class="WMPDB-events">
							<div class="timeline" :style="{'background-image': 'url(' + require('@/assets/whatsapp_background.png') + ')'}">

								<div class="timelineItem">
									<div class="content">2. Slider ı kaldırabilir miyiz ?</div>
									<div class="time">17:00</div>
								</div>
								<div class="timelineItem isWorker">
									<div class="content">Tamamdır</div>
									<div class="time">17:00</div>
								</div>
								<div class="timelineItem isWorker">
									<div class="content">
										<img src="https://pixelclerks.com/pics/415-3xXuZJ1540839949.jpg" alt="">
									</div>
									<div class="time">17:00</div>
								</div>
								<div class="thisLocked">
									<center><v-icon>lock</v-icon></center>
									Onaylandı ve konu kilitlendi
								</div>




							</div>
							<div class="actions">
								<div class="text">
									<textarea placeholder="Cevap yaz"></textarea>
								</div>
								<div class="button">
									<v-btn flat icon color="#108dc6">
										<v-icon>send</v-icon>
									</v-btn>
								</div>
							</div>
						</div>
						<div class="WMPDB-brif">
							<h4 ><center>Brif Bilgileri</center></h4>
							<hr>
							<br> 
							<div><b>Konu:</b> Bilbord tasarımı</div>
							<div><b>Açıklama:</b> Eylül ayı kampanyaları hakkında</div>
						</div>
					</div>

				</div>


			</div>

		</v-container>
	</v-content>


</template>

<script>
export default {
	name : 'WorkManagerIndex',
	data: () => ({
		isOpendDetailsBrif : false
	}),
	computed : { 
	}
}
</script>

<style lang="less">
	.WorkManager {
		height: 100%;
		width: 100%;
		background: #e9ebea;
		display: flex;

		.WMPanel {
			height: 100%;
			background-color: #fff;

			&.WMPanel-customers {
				width: 300px;
				border-right: 1px solid #e9ebea;
			}

			&.WMPanel-works {
				width: 300px;
				border-right: 1px solid #e9ebea;
			}
 

			.WMActionBox {
				background: #f0f0f0;
				text-align: right;
				height: 60px;
						display: flex;
						justify-content: center;
						flex-direction: column; 
			}

			.WMSearchBox {
				border-bottom: 1px solid #e9ebea;
				background-color: #fbfbfb;
				padding: 10px;
				position: relative;

				&::before {
					position: absolute;
					left: 18px;
					top: 12px;
					content: 'search';
					font-family: 'Material Icons';
					font-weight: normal;
					font-style: normal;
					font-size: 21px;  
					color:#aaa;
					-webkit-font-feature-settings: 'liga';
					-webkit-font-smoothing: antialiased;
				}

				input {
					width: 100%;
					background-color: #ffffff;
					border: 1px solid #f5f5f5;
					outline: none;
					height: auto;
					padding: 5px 10px 5px 36px;
					font-size:13px;
					line-height: 24px;
				}
			}

			.WMPanelItems{
				.item{
					height: 60px;
					padding: 10px;
					position: relative; 
					border-bottom: 1px solid #e9ebea;
					cursor: pointer;
					background-color: #ffffff;
					transition: all .3s;
					&:hover,
					&.active{
						background-color: #e9ebea;
					}
					img{
						width:40px;
						height:40px;
						border-radius: 50%;
						object-fit: cover;
						position: absolute;
						left:10px;
						top:10px;
					}
					.details{
						margin-left: 50px;
						height: 40px;
						display: flex;
						justify-content: center;
						flex-direction: column; 
						.first{
							font-weight: 500
						}
					}
				}
			}


			&.WMPanel-details{ 
				flex: 1;
				height: 100%;
				width: 100%;
				overflow: hidden;
				.WMPD-topActions{
					display: flex;
					position: relative;
					background-color: #f0f0f0;
					height:60px;
					.infos{
						position: relative;
						padding-left:60px;
						height:60px;
						flex:1;
						img{
							width:40px;
							height:40px;
							border-radius: 50%;
							object-fit: cover;
							position: absolute;
							left:10px;
							top:10px;
						}
						.details{
							height:60px;
						display: flex;
						justify-content: center;
						flex-direction: column; 
							.customer{
								font-weight: 500;
							}
							.work{
font-size: 12px;
color:#888;
							}
						}
					}
					.actions{
						display: flex;
						justify-content: center;
						flex-direction: column; 
					}
				}
				.WMPD-body{
					height: calc(~"100% - 60px");
					background: red;
					position: relative;
					.WMPDB-events{
						position: absolute;
						left: 0px;
						top:0px;
						height: 100%;
						width:100%;
						transition: all .3s;
						display: flex;
						justify-content: center;
						flex-direction: column; 
						background: green;
						.timeline{
							flex : 1; 
							background: yellow;  
							background-size: 400px auto;
							overflow: hidden;
							overflow-y: auto;
							padding:20px;
							.timelineItem{
								background-color: #fff;
								display: table;
								border-radius: 5px;
								padding: 10px 10px 5px 10px;
								margin-bottom: 10px;
								&::after{
									content : '';
									display: block;
									clear: both;
									position: relative;
								}
								.content{ 
									img{
										max-width: 400px;
								border-radius: 5px;
									}
								}
								.time{
									text-align: right;
									font-size:10px;
									color : #ccc;
								}
								&.isWorker{
									margin-left: auto;
									background-color: #daf8c4;
								}
							}
							.thisLocked{
								display: table;
								margin:10px auto;
								background-color: #daf8c4;
								border-radius: 5px;
								padding:10px 20px;
								// box-shadow: 0 0 10px rgba(0,0,0,.2);
							}
						}
						.actions{
							width:100%;
							min-height: 60px;
							background: #f5f1ee;
							display: flex;
							.text{
								flex : 1;
								padding: 10px;
								textarea{
									width: 100%;
									background-color: #ffffff;
									border: 1px solid #dfdfdf;
									outline: none;
									height: auto;
									padding: 5px 8px; 
									border-radius: 8px;
									resize: none;
									height : 70px
								}
							}
							.button{
								display: flex;
								justify-content: center;
								flex-direction: column; 
								margin-bottom: 10px;
							}
						}
					}
					.WMPDB-brif{
						position: absolute;
						left: 100%;
						top:0px;
						height: 100%;
						width:350px;
						transition: all .3s;
						padding: 20px;
						background: white;
					}
					&.opendBrif{
						.WMPDB-events,.WMPDB-brif{
							transform:translateX(-350px) !important;
						}
					}
				}
			}
		}
	}
</style>